import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import City from "../types/City";

export default function useCityGet (
    id: string,
    options?: CacheQueryOpts
): CacheQueryOutput<City> {
    const client = useAPIClient();
    return useCacheQuery<City>(
        ["hotels", id],
        () => {
            return client.get<any>(id.substring(1));
        },
        options
    );
}